import { render, staticRenderFns } from "./BaixaItemBemConsumoEstornoForm.vue?vue&type=template&id=68a7f678&scoped=true"
import script from "./BaixaItemBemConsumoEstornoForm.vue?vue&type=script&lang=js"
export * from "./BaixaItemBemConsumoEstornoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7f678",
  null
  
)

export default component.exports